exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Yy97{position:relative;width:70%;height:100%}body.reader-night-mode ._1Yy97{background-color:#3d3d3d}", ""]);

// exports
exports.locals = {
	"editor-container": "_1Yy97"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/containers/EditorContainer/EditorContainer.scss
// module id = 2NtZ
// module chunks = 3